import VueRouter from 'vue-router'

//heizoel components
import HeizoelStep1 from '../components/heizoel/HeizoelStep1'
import HeizoelStep2 from '../components/heizoel/HeizoelStep2'
import HeizoelStep3 from '../components/heizoel/HeizoelStep3'
import HeizoelOfferConfirmation from '../components/heizoel/OfferConfirmation'
import HeizoelOrderConfirmation from '../components/heizoel/OrderConfirmation'

//pellets components
import PelletsStep1 from '../components/pellets/PelletsStep1'
import PelletsStep2 from '../components/pellets/PelletsStep2'
import PelletsStep3 from '../components/pellets/PelletsStep3'
import PelletsOfferConfirmation from '../components/pellets/OfferConfirmation'
import PelletsOrderConfirmation from '../components/pellets/OrderConfirmation'

//diesel components
import DieselStep1 from '../components/diesel/DieselStep1'
import DieselStep2 from '../components/diesel/DieselStep2'
import DieselStep3 from '../components/diesel/DieselStep3'
import DieselOfferConfirmation from '../components/diesel/OfferConfirmation'
import DieselOrderConfirmation from '../components/diesel/OrderConfirmation'

//tankrevision components
import TankrevisionStep1 from '../components/tankrevision/TankrevisionStep1'
import TankrevisionStep2 from '../components/tankrevision/TankrevisionStep2'
import TankrevisionStep3 from '../components/tankrevision/TankrevisionStep3'
import TankrevisionOfferConfirmation from '../components/tankrevision/TankrevisionOfferConfirmation'
import TankrevisionOrderConfirmation from '../components/tankrevision/TankrevisionOrderConfirmation'

//diesel components
import BoilerentkalkungStep1 from '../components/boilerentkalkung/BoilerentkalkungStep1'
import BoilerentkalkungStep2 from '../components/boilerentkalkung/BoilerentkalkungStep2'
import BoilerentkalkungStep3 from '../components/boilerentkalkung/BoilerentkalkungStep3'
import BoilerentkalkungOfferConfirmation from '../components/boilerentkalkung/BoilerentkalkungOfferConfirmation'
import BoilerentkalkungOrderConfirmation from '../components/boilerentkalkung/BoilerentkalkungOrderConfirmation'

//common components
import OfferExpired from '../components/OfferExpired'
import OfferNotFound from '../components/OfferNotFound'
import OfferAlreadyOrdered from '../components/OfferAlreadyOrdered'
import GenericError from '../components/GenericError'
import ShopDisabled from '../components/ShopDisabled'

export default function createRouter(settings, store) {

    var routes = [];

    if (store.state.PricingDisabled) {
        routes.push({
            path: '/',
            component: ShopDisabled,
            meta: { isFinalStep: true, isEntryStep: true }
        });
    } else {

        switch (settings.transaction.ProductType) {
            case 'Heizoel':
                if (settings.transaction.OfferId) {
                    routes.push({
                        path: '/',
                        component: HeizoelStep3,
                        props: { stepMode: 'order' },
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: HeizoelOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                } else {
                    routes.push({
                        path: '/',
                        component: HeizoelStep1,
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/offer-addresses',
                        component: HeizoelStep2,
                        props: { stepMode: 'offer' }
                    });
                    routes.push({
                        path: '/order-addresses',
                        component: HeizoelStep2,
                        props: { stepMode: 'order' }
                    });
                    routes.push({
                        path: '/offer-review',
                        component: HeizoelStep3,
                        props: { stepMode: 'offer' }
                    });
                    routes.push({
                        path: '/order-review',
                        component: HeizoelStep3,
                        props: { stepMode: 'order' }
                    });
                    routes.push({
                        path: '/offer-confirmation',
                        component: HeizoelOfferConfirmation,
                        meta: { isFinalStep: true }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: HeizoelOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                }
                break;
            case 'Pellets':
                if (settings.transaction.OfferId) {
                    routes.push({
                        path: '/',
                        component: PelletsStep3,
                        props: { stepMode: 'order' },
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: PelletsOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                } else {
                    routes.push({
                        path: '/',
                        component: PelletsStep1,
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/offer-addresses',
                        component: PelletsStep2,
                        props: { stepMode: 'offer' }
                    });
                    routes.push({
                        path: '/order-addresses',
                        component: PelletsStep2,
                        props: { stepMode: 'order' }
                    });
                    routes.push({
                        path: '/offer-review',
                        component: PelletsStep3,
                        props: { stepMode: 'offer' }
                    });
                    routes.push({
                        path: '/order-review',
                        component: PelletsStep3,
                        props: { stepMode: 'order' }
                    });
                    routes.push({
                        path: '/offer-confirmation',
                        component: PelletsOfferConfirmation,
                        meta: { isFinalStep: true }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: PelletsOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                }
                break;
            case 'Diesel':
                if (settings.transaction.OfferId) {
                    routes.push({
                        path: '/',
                        component: DieselStep3,
                        props: { stepMode: 'order' },
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: DieselOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                } else {
                    routes.push({
                        path: '/',
                        component: DieselStep1,
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/offer-addresses',
                        component: DieselStep2,
                        props: { stepMode: 'offer' }
                    });
                    routes.push({
                        path: '/order-addresses',
                        component: DieselStep2,
                        props: { stepMode: 'order' }
                    });
                    routes.push({
                        path: '/offer-review',
                        component: DieselStep3,
                        props: { stepMode: 'offer' }
                    });
                    routes.push({
                        path: '/order-review',
                        component: DieselStep3,
                        props: { stepMode: 'order' }
                    });
                    routes.push({
                        path: '/offer-confirmation',
                        component: DieselOfferConfirmation,
                        meta: { isFinalStep: true }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: DieselOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                }
                break;
            case 'Tankrevision':
                if (settings.transaction.OfferId) {
                    routes.push({
                        path: '/',
                        component: TankrevisionStep3,
                        props: { stepMode: 'order' },
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: TankrevisionOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                } else {
                    routes.push({
                        path: '/',
                        component: TankrevisionStep1,
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/equipment',
                        component: TankrevisionStep2
                    });
                    routes.push({
                        path: '/offer-review',
                        component: TankrevisionStep3,
                        props: { stepMode: 'offer' }
                    });
                    routes.push({
                        path: '/offer-confirmation',
                        component: TankrevisionOfferConfirmation,
                        meta: { isFinalStep: true }
                    });
                    routes.push({
                        path: '/order-review',
                        component: TankrevisionStep3,
                        props: { stepMode: 'order' }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: TankrevisionOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                }
                break;
            case 'Boilerentkalkung':
                if (settings.transaction.OfferId) {
                    routes.push({
                        path: '/',
                        component: BoilerentkalkungStep3,
                        props: { stepMode: 'order' },
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: BoilerentkalkungOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                } else {
                    routes.push({
                        path: '/',
                        component: BoilerentkalkungStep1,
                        meta: { isEntryStep: true }
                    });
                    routes.push({
                        path: '/equipment',
                        component: BoilerentkalkungStep2
                    });
                    routes.push({
                        path: '/offer-review',
                        component: BoilerentkalkungStep3,
                        props: { stepMode: 'offer' }
                    });
                    routes.push({
                        path: '/offer-confirmation',
                        component: BoilerentkalkungOfferConfirmation,
                        meta: { isFinalStep: true }
                    });
                    routes.push({
                        path: '/order-review',
                        component: BoilerentkalkungStep3,
                        props: { stepMode: 'order' }
                    });
                    routes.push({
                        path: '/order-confirmation',
                        component: BoilerentkalkungOrderConfirmation,
                        meta: { isFinalStep: true }
                    });
                }
                break;
        }

    }

    routes.push({
        path: '/offer-expired',
        component: OfferExpired,
        meta: { isFinalStep: true, isEntryStep: true }
    });

    routes.push({
        path: '/offer-not-found',
        component: OfferNotFound,
        meta: { isFinalStep: true, isEntryStep: true }
    });

    routes.push({
        path: '/offer-already-ordered',
        component: OfferAlreadyOrdered,
        meta: { isFinalStep: true, isEntryStep: true }
    });

    routes.push({
        path: '/error',
        component: GenericError,
        meta: { isFinalStep: true, isEntryStep: true }
    });

    //add a "catch-all" handler and redirect to the standard 404 page
    routes.push({
        path: '*',
        beforeEnter(to, from, next) {
            next(false);
            window.location.replace('/' + window.CONFIG.language + '/404');
        }
    });

    var router = new VueRouter({
        mode: 'hash',
        fallback: false, //no backwards compatibility for old browsers
        routes: routes,
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                return { x: 0, y: 0 }
            }
        }
    });

    //this route guard prevents the user from going back (e.g. with the browser's back button) once a final step is reached (meta isFinalStep == true)
    //in this case, the user is just redirected to the start page of the shop (re-initializing the shop in the process)
    router.beforeEach((to, from, next) => {

        //check if an entry page has been loaded already and if not, makes sure "to" points to a valid entry route
        if (!store.state.EntryPageLoaded) {
            if (to.meta.isEntryStep) {
                //all good
                next();
                store.commit('setEntryPageLoaded');
                return;
            } else {
                //requested route is not an entry page -> redirect to /
                next('/');
                return;
            }
        }

        //if we are in the final step, prevent users from going back (via browser back). if navigation occurs, do a full redirect to "/" (not via routing, so the whole shop is re-initialized)
        if (from.meta && from.meta.isFinalStep) {
            next(false);
            window.document.location.href = window.document.location.pathname;
            return;
        } else {
            next();
            return;
        }
    });

    return router;
}